<template>
  <div>
    <top-title :name="name"></top-title>

    <div v-if="!peopleFilter" class="member-box">
      <div>
        <el-alert title type="info" :closable="false" class="global-comment" show-icon>
          <template slot="title">
            <div class="tip-alert">
              <div class="tip-content" style="font-size:14px;">
                <p>1.此功能为京东官方功能，请先报备店铺签名，再筛选人群数据哦；且短信发送后第二天才可查看营销效果分析~ </p>
                <p>2.官方规定：每个商家的人群策略最多创建200个（不包含系统人群），若您的策略已到达上限，请先删除一些无用分组，再进行人群创建</p>
              </div>
            </div>
          </template>
        </el-alert>
      </div>
      <div class="member-content">
        <div class="search-form">
          <div class="form-item">
            <div class="form-label">
              人群名称：
            </div>
            <div class="form-value">
              <el-input size="small" v-model="form.xxx1" placeholder="请输入人群名称"></el-input>
            </div>
          </div>
          <div class="form-item">
            <div class="form-label">
              人群描述：
            </div>
            <div class="form-value">
              <el-input size="small" v-model="form.xxx1" placeholder="请输入人群描述"></el-input>
            </div>
          </div>
          <div class="form-item" style="margin-right: 0">
            <el-button
             :style="{'color': globalBG, 'border-color': globalBG}"
             icon="el-icon-search"  >查询</el-button>
            <el-button>重置</el-button>
          </div>
          <div class="form-right">
            <span>100/200</span>
            <el-button type="primary" icon="el-icon-circle-plus" @click="showPeopleFilter">创建人群</el-button>
          </div>
        </div>
        <div class="switch-tab">
          <div class="tab-item" @click="switchTab(0)" :class="{'active': switchIndex == 0}" :style="{'color': switchIndex == 0 ? globalBG: '', 'border-top-color': switchIndex == 0 ? globalBG: '' }">全部人群</div>
          <div class="tab-item" @click="switchTab(1)" :class="{'active': switchIndex == 1}" :style="{'color': switchIndex == 1 ? globalBG: '', 'border-top-color': switchIndex == 1 ? globalBG: '' }">自定义人群</div>
          <div class="tab-item" @click="switchTab(2)" :class="{'active': switchIndex == 2}" :style="{'color': switchIndex == 2 ? globalBG: '', 'border-top-color': switchIndex == 2 ? globalBG: '' }">系统人群</div>
        </div>
        <div class="form-content">
          <el-table
            v-loading="tableLoading"
            :data="tableData"
            tooltip-effect="light"
            :header-cell-style="{background:'#FAFAFA'}"
          >
            <el-table-column prop="xxx1" label="人群名称"> </el-table-column>
            <el-table-column prop="xxx2" label="人群数量（人）"> </el-table-column>
            <el-table-column prop="xxx3" label="人群类型"> </el-table-column>
            <el-table-column prop="xxx4" label="人群描述"> </el-table-column>
            <el-table-column prop="xxx5" label="创建时间"> </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <div class="operation-btn">
                  <el-button type="text" @click="handleAccurate">营销</el-button>
                  <el-button type="text" @click="handleEdit" style="color: #7F85E9">编辑</el-button>
                  <el-button type="text">删除</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-sizes="[10, 20, 30, 50 , 100 ,500]"
              :page-size="form.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalList"
              :current-page="form.pageNum"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- 人群筛选 -->
    <people-filter @on-cancel="onCancel" v-if="peopleFilter"></people-filter>
  </div>
</template>

<script>
import topTitle from "@/components/top-title.vue";
import peopleFilter from "@/components/people-filter";
import { mapState, mapMutations } from "vuex";
export default {
  name: "member_grouping",
  components: {
    topTitle,
    peopleFilter
  },
  computed: {
    ...mapState({
      globalBG: "globalBG"
      //   把city映射给currentCIty
    })
  },
  data() {
    return {
      name: "会员分群",
      form: {
        xxx1: '',
        pageSize: 10,
        pageNum: 1
      },
      switchIndex: 0,
      tableLoading: false,
      tableData: [{
        xxx1: '关注店铺',
        xxx2: '110',
        xxx3: '系统人群',
        xxx4: '关注店铺',
        xxx5: '2019-07-02 00：00：00'
      }],
      totalList: 100,
      peopleFilter: false,
    };
  },
  methods: {
    switchTab(index) {
      this.switchIndex = index;
    },
    handleSizeChange(val) {
      this.form.pageSize = val;
    },

    handleCurrentChange(val) {
      this.form.pageNum = val;
    },

    // 创建人群按钮
    showPeopleFilter() {
      this.peopleFilter = true;
    },
    onCancel() {
      this.peopleFilter = false;
    },
    // 编辑按钮
    handleEdit() {
      this.peopleFilter = true;
    },
    // 营销页面
    handleAccurate() {
      this.$router.push({
        path: "/marketing/marketing/accurate_market",
        // query: { to: "/marketing/accurate_market" }
      });

      // let routeUrl = this.$router.resolve({
      //   path: "/accurate_market",
      //   query: { to: "/marketing/accurate_market" }
      // });
      // window.open(routeUrl.href, "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
.el-button{
  width: 98px;
}
.pagination{
  text-align: right;
  margin-top: 20px;
}
.member-box{
  padding: 20px;
  color: #333;
  .member-content{
    box-shadow:0px 4px 8px rgba(0,0,0,0.1);
    border-radius: 6px;
    background: #fff;
    padding: 20px 28px;
    margin-top: 20px;
    .search-form{
      .form-item{
        display: inline-block;
        margin-right: 138px;
        .form-label{
          display: inline-block;
          text-align: right;
          width: 98px;
        }
        .form-value{
          display: inline-block;
        }
      }
      .form-right{
        float: right;
        span{
          margin-right: 12px;
        }
      }
      &::after{
        content: '';
        clear: both;
        display: block;
        width: 0;
        height: 0;
        overflow: hidden;
      }
    }
    .switch-tab{
      border-bottom: 1px solid #ddd;
      margin-top: 20px;
      .tab-item{
        cursor: pointer;
        display: inline-block;
        width: 105px;
        height: 36px;
        line-height: 36px;
        box-sizing: border-box;
        color: #666;
        border: 1px solid #DDDDDD;
        border-bottom: none;
        text-align: center;
        border-top-left-radius: 2px;
        border-top-right-radius: 2px;
        margin-right: 1px;
        &.active{
          border-top-width: 2px;
          position: relative;
          &::after{
            position: absolute;
            content: '';
            width: 100%;
            height: 2px;
            background-color: #fff;
            bottom: -2px;
            left: 0;
          }
        }
      }
    }
    .form-content{
      margin-top: 20px;
      .operation-btn{
        .el-button{
          width: 30px;
          margin-right: 20px;
        }
      }
    }
  }
}
.global-comment.el-alert{
  align-items: normal!important;
  background-color: #FFF4F4;
  border: 1px solid #FE8F8A;
  /deep/.el-icon-info{
    color: #FE4D45;
    font-size: 14px;
  }
  .tip-alert{
    color: #333;
    .tip-title{
      font-size: 14px;
      font-weight: 500;
    }
    .tip-content{
      // margin-top: 5px;
      p{
        font-size: 14px;
        margin: 0;
        color: #333;
      }
    }
  }
}

</style>